module.exports = __webpack_public_path__ + "img/superhero.c8b7b701.png";